import {kebabCase, snakeCase} from 'lodash';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';

export const packId = (objectType: string = '', id: string) => {
   return `${encodeObjectType(objectType)}/${id}`;
};

export const unpackId = (diplomatId: string = '') => {
   let [objectType, id] = diplomatId.split('/');
   if (!id) {
      id = diplomatId;
   }
   return {
      id,
      objectType: decodeObjectType(objectType),
   };
};

export type IdObject = ReturnType<typeof unpackId>;

export const encodeObjectType = (objectType: string) => kebabCase(objectType);
export const decodeObjectType = (objectType?: string) =>
   snakeCase(objectType).toUpperCase() as DiplomatObjectTypeUnion;
